import { render, staticRenderFns } from "./titleTwo.vue?vue&type=template&id=1b82220b&scoped=true&"
import script from "./titleTwo.vue?vue&type=script&lang=js&"
export * from "./titleTwo.vue?vue&type=script&lang=js&"
import style0 from "./titleTwo.vue?vue&type=style&index=0&id=1b82220b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b82220b",
  null
  
)

export default component.exports